import React, { useState, useRef, useEffect } from "react";
import Scrollbar from "react-scrollbars-custom";
import socialServices from "fantastic/components/common/controls/social/services";

const SocialPack = ({socials, onChange, displayServices}) => {

  const [query, setQuery] = useState('');
  const inputRef = useRef(null);

  useEffect(() => inputRef.current.focus());

  const addService = (service) => {
    const alreadyExists = socials.filter((social) => social.srv === service).length
    if (alreadyExists) return null

    const value = [...socials, { srv: service, url: "" }]
    onChange('socials', value)
    displayServices(false)
  }

  const exists = socials.map(social => social.srv);
  const availableServices = socialServices().filter(name => !exists.includes(name));

  const filterServices = () => {
    if(query.length <= 0) return availableServices;

    return availableServices.filter(name => name.toLowerCase().search(query.toLowerCase()) !== -1);
  };

  return (
    <>
      <div className="social-form__items-wrapper">
        <Scrollbar noDefaultStyles={true}>
          <div className="social-form__items">
            { filterServices().map((service, index) => {
                return(
                  <div className='social-form__item' key={`social-default-id-${index}`}
                    onClick={() => addService(service)} title={service}>
                    <a><img src={`/social/${service}_32.png`}></img></a>
                  </div>
                )
              })
            }
          </div>
        </Scrollbar>
        <input className="form-control fantastic-form-control social-form__filter" type="text" value={query}
               placeholder={i18n.t('search')}
               onChange={(e) => setQuery(e.target.value)}
               ref={inputRef}
               />
      </div>
    </>
  );
}

export default SocialPack;
